type ColorSpec = { fg: string; bg: string };

const MAP: Record<string, ColorSpec> = {
  Angelegt: { fg: "var(--status-new)", bg: "color-mix(in oklab, var(--status-new) 12%, var(--bg-card))" },
  Bestätigt: { fg: "var(--status-confirm)", bg: "color-mix(in oklab, var(--status-confirm) 14%, var(--bg-card))" },
  "Konus Link versandt": {fg: "var(--status-konus-link)", bg: "color-mix(in oklab, var(--status-konus) 14%, var(--bg-card))",},
  "Konus-Daten eingegeben": { fg: "var(--status-konus)", bg: "color-mix(in oklab, var(--status-konus) 14%, var(--bg-card))" },
  "Infos an Gruppe versandt": {
    fg: "var(--status-info)",
    bg: "color-mix(in oklab, var(--status-info) 14%, var(--bg-card))",
  },
  Abgereist: { fg: "var(--status-done)", bg: "color-mix(in oklab, var(--status-done) 14%, var(--bg-card))" },
  "Rechnung erstellt": {
    fg: "var(--status-bill)",
    bg: "color-mix(in oklab, var(--status-bill) 14%, var(--bg-card))",
  },
  Bezahlt: { fg: "var(--status-closed)", bg: "color-mix(in oklab, var(--status-closed) 14%, var(--bg-card))" },
  Storniert: { fg: "var(--status-cancel)", bg: "color-mix(in oklab, var(--status-cancel) 12%, var(--bg-card))" },
  Intern: { fg: "var(--status-intern)", bg: "color-mix(in oklab, var(--status-intern) 12%, var(--bg-card))" },
  // Anfrage-Status (booking_inquiries_raw)
  new: { fg: "var(--status-bill)", bg: "color-mix(in oklab, var(--status-bill) 14%, var(--bg-card))" },
  verified: { fg: "var(--status-new)", bg: "color-mix(in oklab, var(--status-new) 14%, var(--bg-card))" },
  imported: { fg: "var(--status-closed)", bg: "color-mix(in oklab, var(--status-closed) 14%, var(--bg-card))" },
  rejected: { fg: "var(--status-cancel)", bg: "color-mix(in oklab, var(--status-cancel) 12%, var(--bg-card))" },
};

// Rohwerte aus der DB, die für die Anzeige übersetzt werden (Anfrage-Status).
const LABELS: Record<string, string> = {
  new: "Neu (unbestätigt)",
  verified: "Verifiziert",
  imported: "Übernommen",
  rejected: "Abgelehnt",
};

const FALLBACK: ColorSpec = { fg: "var(--fg-muted)", bg: "var(--bg-subtle)" };

export function StatusPill({ status }: { status: string }) {
  const c = MAP[status] ?? FALLBACK;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 5,
        padding: "2px 8px",
        borderRadius: 999,
        fontSize: 11,
        fontWeight: 600,
        color: c.fg,
        background: c.bg,
        border: `1px solid ${c.fg}22`,
        whiteSpace: "nowrap",
      }}
    >
      <span style={{ width: 6, height: 6, borderRadius: "50%", background: c.fg }} />
      {LABELS[status] ?? status}
    </span>
  );
}
